import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";

const BalanceSheet = (props) => {
  // const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);

  const handleDownload = () => {
    alert("Downloading balance sheet...");
  };

  return (
    <>
      <div className="page-content">
        <Container>
          <Card>
            <CardBody>
              <div className="d-flex gap-2 text-end justify-content-end">
                <div className="d-flex justify-content-center justify-content-md-end mb-3">
                  <Button color="success" onClick={handleDownload}>
                    Download
                  </Button>
                </div>
              </div>

              <CardHeader style={{ textAlign: "center", fontWeight: "bold" }}>
                <p>नमुना बचत तथा ऋण सहकारी संस्था लि.</p>
                <p>सुनपा ४, धादिकोट</p>
                <p>वासलात</p>
                <p>आषाढ़ मासन्तको</p>
              </CardHeader>
              <table className="table table-bordered table-stripped responsive">
                <thead>
                  <tr className="secondary">
                    <th className="text-start">पूँजी तथा दायित्व</th>
                    <th className="text-start">अनुसूची</th>
                    <th className="text-start">यस वर्ष (रु)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-start">शेयर पुँजी</td>
                    <td>1</td>
                    <td className="text-end">72,639,700.00</td>
                  </tr>
                  <tr>
                    <td className="text-start">जग्गा तथा अन्य कोष</td>
                    <td>2</td>
                    <td className="text-end">88,994,727.95</td>
                  </tr>
                  <tr>
                    <td className="text-start">आइचिक तथा विविध कोष</td>
                    <td>2-s_</td>
                    <td className="text-end">5,933,499.07</td>
                  </tr>

                  <tr>
                    <td className="text-start">निचेप दायित्व</td>
                    <td>3</td>
                    <td className="text-end">2,045,781,236.51</td>
                  </tr>
                  <tr>
                    <td className="text-start">चालु दायित्व</td>
                    <td>4</td>
                    <td className="text-end">5,532,155.16</td>
                  </tr>
                  <tr>
                    <td className="text-start">चालु दायित्व</td>
                    <td>4</td>
                    <td className="text-end">5,532,155.16</td>
                  </tr>
                  <tr>
                    <td className="text-start">ऋण नोक्सानी व्यवस्था </td>
                    <td>5</td>
                    <td className="text-end">6,854,588.59</td>
                  </tr>
                  <tr>
                    <td className="text-start">आयकर व्यवस्था</td>
                    <td></td>
                    <td className="text-end">1,702,661.45</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      जम्मा
                    </td>
                    <td style={{ fontWeight: "bold" }}></td>
                    <td style={{ fontWeight: "bold" }} className="text-end">
                      2,227,438,568.73
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table table-bordered table-stripped responsive">
                <thead>
                  <tr>
                    <th className="text-start">सम्पत्ति तथा जा​यजेठा </th>
                    <th className="text-start">अनुसूची</th>
                    <th className="text-start">यस वर्ष (रु)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-start">नगद तथा बैंक मौजूद​</td>
                    <td>6</td>
                    <td className="text-end">336,944,324.27</td>
                  </tr>
                  <tr>
                    <td className="text-start">शेयर लगानी</td>
                    <td>7</td>
                    <td className="text-end">3,050,700.00</td>
                  </tr>
                  <tr>
                    <td className="text-start">
                      आवधिक् वचत तथा बैंक मुद्दती लगानी
                    </td>
                    <td>8</td>
                    <td className="text-end">1,115,000,000.00</td>
                  </tr>
                  <tr>
                    <td className="text-start">ऋण लगानी</td>
                    <td>9</td>
                    <td className="text-end">685,458,859.00</td>
                  </tr>
                  <tr>
                    <td className="text-start">अन्य सम्पत्ति </td>
                    <td>10</td>
                    <td className="text-end">51,106,051.86</td>
                  </tr>

                  <tr>
                    <td className="text-start">स्थिर सम्पत्ति</td>
                    <td>11</td>
                    <td className="text-end">35,878,633.60</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} className="text-start">
                      जम्मा
                    </td>
                    <td></td>
                    <td style={{ fontWeight: "bold" }} className="text-end">
                      2,227,438,568.73
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default BalanceSheet;
